import { computed, ref } from 'vue'
import { isFunction } from '@/global/utils/utils'

const TAB_KEY = 'attachments'

export function useAttachments (options) {
  const { translate, attachmentsTabComponent, tabActionsComponent } = options || {}

  const saveCallbackRef = ref(null)
  const cancelCallbackRef = ref(null)
  // Backend-driven per-tab permission - locked by default; only an explicit
  // `meta.can_edit === true` from the API unlocks the tab.
  const canEdit = ref(false)

  const registerSaveCallback = (fn) => {
    saveCallbackRef.value = fn
  }

  const registerCancelCallback = (fn) => {
    cancelCallbackRef.value = fn
  }

  const setCanEdit = (value) => {
    canEdit.value = value === true
  }

  const onSaveClick = () => {
    if (isFunction(saveCallbackRef.value)) {
      saveCallbackRef.value()
    }
  }

  const onCancelTabSave = () => {
    if (isFunction(cancelCallbackRef.value)) {
      cancelCallbackRef.value()
    }
  }

  const tabActions = computed(() => ({
    component: tabActionsComponent,
    title: translate('road-maintenance/temporary_regulation.attachments'),
    showEditButtons: true,
    showEditBtn: canEdit.value,
    showBackButton: { uiViewName: 'TemporaryRegulationsRequests' },
    visible: true,
    onSaveClick,
    onCancelTabSave
  }))

  const attachmentsBlock = computed(() => ({
    component: attachmentsTabComponent,
    visible: true,
    registerSaveCallback,
    registerCancelCallback,
    setCanEdit
  }))

  return computed(() => ({
    title: translate('road-maintenance/temporary_regulation.attachments'),
    key: TAB_KEY,
    tabContent: [tabActions.value, attachmentsBlock.value]
  }))
}
